import { BaseApiService } from "./baseApiService";
import type {IPostPage} from "./dto/IEvent";
import type {IStream} from "./dto/IStream";
import type {ISelector} from "./dto/IStream";

class EventRepository extends BaseApiService {
  constructor() {
    super("");
  }

  fetchAllEventsClient = (sport: IPostPage, signal?: AbortSignal) =>
    this.otherGet<string[]>(`events/v3/sorted-and-published?${Object.entries(sport).map(([key, value]) => `${key}=${value}`).join("&")}&days=6`, signal);

  fetchStreamsByMatchClient = (id: string) => this.otherPost<{collection: Record<string, IStream[]>}[]>("events/streams", { event_uuid: id });

  fetchStreamsByLeague = (id: string, signal?: AbortSignal) => this.otherPost<IStream[]>("leagues/streams", { league_uuid: id }, signal);

  fetchStreamsSelector = () => this.otherGet<ISelector[]>("eptemplates/zuzz");
}

export const eventRepository = new EventRepository();
